import { Hourglass } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { useAuth } from '@/hooks/useAuth';
import { useT } from '@/i18n/useT';
import { api } from '@/lib/api';

/**
 * Shown to a logged-in account that isn't approved yet (private beta, issue #28):
 * pending admin approval, or blocked. Calm and dead-simple — just says to wait,
 * with a way to sign out.
 */
export function WaitingApproval() {
  const t = useT();
  const { auth } = useAuth();
  const blocked = auth?.user.access === 'blocked';

  const logout = async () => {
    await api('/auth/logout', { method: 'POST' });
    window.location.href = '/login';
  };

  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-5 bg-bg px-6 text-center">
      <div className="flex h-16 w-16 items-center justify-center rounded-[24px] bg-surface-2 text-brand">
        <Hourglass size={30} aria-hidden />
      </div>
      <div className="max-w-xs">
        <h1 className="text-[22px] font-bold tracking-tight text-content">{t('waiting.title')}</h1>
        <p className="mt-2 text-[15px] leading-relaxed text-muted">
          {blocked ? t('waiting.blocked') : t('waiting.body')}
        </p>
      </div>
      <Button variant="secondary" onClick={logout}>
        {t('waiting.logout')}
      </Button>
    </div>
  );
}
